/**
 * ==================== NOT FOUND PAGE ====================
 * Página 404 genérica para rotas não encontradas.
 * Usada também pelo Admin Shield para ocultar painel admin.
 * ========================================================
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, AlertCircle } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="bg-slate-200 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertCircle className="w-10 h-10 text-slate-500" />
        </div>
        
        <h1 className="text-6xl font-bold text-slate-300 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-slate-700 mb-2">Página não encontrada</h2>
        <p className="text-slate-500 mb-8">
          A página que você está procurando não existe ou foi removida.
        </p>
        
        <Button 
          onClick={() => navigate('/')}
          className="bg-[#2563EB] hover:bg-[#2563EB]/90"
        >
          <Home className="w-4 h-4 mr-2" />
          Voltar ao início
        </Button>
      </div>
    </div>
  );
}
